import { useQuery } from "react-query";

import { agentOfficeSetupService } from "services";

type UseAgentOfficeGeneralInfoQueryProps = {
	companyId: string;
	options?: any;
};

const useAgentOfficeGeneralInfoQuery = ({
	companyId,
	options,
}: UseAgentOfficeGeneralInfoQueryProps) =>
	useQuery(
		"getAgentOfficeGeneralInfo",
		() => agentOfficeSetupService.getEditAgentOfficeForm(companyId),
		{
			...options,
		},
	);

export default useAgentOfficeGeneralInfoQuery;
